__turbopack_context__.v({
  "clothing-info-badge": "list-selector-module-scss-module__JofAKG__clothing-info-badge",
  "clothing-info-bottom-text": "list-selector-module-scss-module__JofAKG__clothing-info-bottom-text",
  "mobile-help-closer": "list-selector-module-scss-module__JofAKG__mobile-help-closer",
  "mobile-help-text-wrapper": "list-selector-module-scss-module__JofAKG__mobile-help-text-wrapper",
  "value-description": "list-selector-module-scss-module__JofAKG__value-description",
  "value-name": "list-selector-module-scss-module__JofAKG__value-name",
});
